module.exports = __webpack_public_path__ + "img/gcash-how-it-works-5.197186ea.png";